module.exports = __webpack_public_path__ + "static/media/G1-5-Julie-Asker-cod25.dc2903c0.png";